import service from '@/utils/request'

/** 获取用户身份列表 */
export function getMemberLevels(params) {
  return service.get('/backend/member/level/list', { params })
}

/** 获取用户列表 */
export function getMemberList(params) {
  return service.get('/backend/member/list', { params })
}

/** 获取用户详情 */
export function getMemberDetail(id) {
  return service.get(`/backend/member/detail/${id}`)
}

/** 根据关键词查找用户 */
export function searchByKeyword(params) {
  return service.get(`/backend/member/detail`, { params })
}

/** 更改用户合伙人身份 */
export function changePartnership(data) {
  return service.post('/backend/member/detail/partnership', data)
}

/** 获取资产统计数据 */
export function getMemberAssets(memberId) {
  return service.get(`/backend/member/assets/info?memberId=${memberId}`)
}

/** 获取资产明细数据列表 */
export function getAssetsDetail(params) {
  return service.get(`/backend/member/assets/detail`, { params })
}

/** 给用户转积分和券 */
export function transferAssets(data) {
  return service.post(`/backend/member/assets/transfer`, data)
}
